import { z } from "zod";

export const NotificationDisplayParamsSchema = z.object({
  taskType: z.string().optional().meta({ visibleTo: "*" }),
  taskTitle: z.string().optional().meta({ visibleTo: "*" }),
  caseNumber: z.number().int().optional().meta({ visibleTo: "*" }),
  clientName: z.string().optional().meta({ visibleTo: "*" }),
  step: z.string().optional().meta({ visibleTo: "*" }),
  previousStep: z.string().optional().meta({ visibleTo: "*" }),
  documentName: z.string().optional().meta({ visibleTo: "*" }),
  noteExcerpt: z.string().optional().meta({ visibleTo: "*" }),
  reminderComment: z.string().optional().meta({ visibleTo: "*" }),
  conversationLabel: z.string().optional().meta({ visibleTo: "*" }),
  signInLocation: z.string().optional().meta({ visibleTo: "*" }),
  signInDevice: z.string().optional().meta({ visibleTo: "*" }),
  completionAudience: z.enum(["creator", "open_task"]).optional().meta({ visibleTo: "*" }),
});

export const NotificationLinkSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("task").meta({ visibleTo: "*" }),
    taskId: z.uuid().meta({ visibleTo: "*" }),
  }),
  z.object({
    type: z.literal("case").meta({ visibleTo: "*" }),
    caseId: z.uuid().meta({ visibleTo: "*" }),
    caseNumber: z.number().int().optional().meta({ visibleTo: "*" }),
    tab: z.string().optional().meta({ visibleTo: "*" }),
    historyEntryId: z.string().min(1).optional().meta({ visibleTo: "*" }),
  }),
  z.object({
    type: z.literal("client").meta({ visibleTo: "*" }),
    clientId: z.uuid().meta({ visibleTo: "*" }),
  }),
  z.object({
    type: z.literal("conversation").meta({ visibleTo: "*" }),
    conversationId: z.string().min(1).meta({ visibleTo: "*" }),
  }),
  z.object({
    type: z.literal("url").meta({ visibleTo: "*" }),
    href: z.string().min(1).meta({ visibleTo: "*" }),
  }),
  z.object({ type: z.literal("notifications").meta({ visibleTo: "*" }) }),
]);

export const NotificationActionSchema = z.object({
  label: z.string().min(1).meta({ visibleTo: "*" }),
  href: z.string().min(1).meta({ visibleTo: "*" }),
});
